export default __webpack_public_path__ + "static/media/about_mobile.e70776df.jpg";